import React from 'react';
import styled from 'styled-components';

export enum DashboardType {
  Epds = 'epds',
  CopyGroups = 'copyGroups',
}

interface Props {
  value: DashboardType;
  onChange: (value: DashboardType) => void;
}

const DashboardTypeToggle: React.FC<Props> = ({ value, onChange }) => (
  <Wrapper role="group">
    <Tab
      type="button"
      aria-pressed={value === DashboardType.Epds}
      $active={value === DashboardType.Epds}
      onClick={() => onChange(DashboardType.Epds)}
    >
      EPDs
    </Tab>
    <Tab
      type="button"
      aria-pressed={value === DashboardType.CopyGroups}
      $active={value === DashboardType.CopyGroups}
      onClick={() => onChange(DashboardType.CopyGroups)}
    >
      Copy Groups
    </Tab>
  </Wrapper>
);

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  min-height: 30px;
  background-color: ${(props) => props.theme.colors.elementsDropDown};
  margin-bottom: 10px;
`;

const Tab = styled.button<{ $active: boolean }>`
  border: none;
  cursor: pointer;
  padding: 3px 6px;
  border-radius: 4px;
  font-family: Inter;
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  text-transform: uppercase;
  min-height: 22px;

  background-color: ${({ $active, theme }) => ($active ? theme.colors.primaryWhite : 'transparent')};
  color: ${({ $active, theme }) => ($active ? theme.colors.primaryGreen : theme.colors.primaryBlack70)};

  &:hover {
    color: ${(props) => props.theme.colors.primaryGreen};
  }
`;

export default DashboardTypeToggle;
